// Servizio CMP (Cookie Consent Management): config pubblica, invio consenso e admin.
import { api, unwrap } from './client';

export const cookieService = {
  // pubblico
  publicConfig: () => unwrap(api.get('/cookie/config')),
  submitConsent: (body) => unwrap(api.post('/cookie/consent', body)),
  // admin
  getConfig: () => unwrap(api.get('/cookie/admin/config')),
  updateConfig: (body) => unwrap(api.put('/cookie/admin/config', body)),
  listConsents: (params) => unwrap(api.get('/cookie/admin/consents', { params })),
  consentsCsvBlob: () => unwrap(api.get('/cookie/admin/consents.csv', { responseType: 'blob' })),
};
